








































































































/**
 * @file PDFのダウンロードリストを取得するコンポーネント
 */
import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  Conditions,
  PageLink
} from '../../modules/class/PdfDownload/Conditions'
import { DownloadLinkInfo } from '../../modules/class/Downloads'
import GetParameter from '../../modules/util/GetParameter'
import { createCustomEvent } from '../../modules/CustomEvent'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

@Component({
  components: { RemoveTag }
})
export default class PdfList extends Vue {
  @Prop() private conditions!: Conditions
  @Prop() private pdfList!: DownloadLinkInfo[]
  private clicked: number[] = []

  // --------------------------------------------------------------------------------------------------------------------
  // computed

  /**
   * Configフィールドを持つかの可否
   */
  get hasConfigColumn(): boolean {
    // 表示対象の中にコンフィグを表示するデータが存在するか判定
    for (const p of this.pdfList) {
      const config = this.getConfigModalId(p)
      if (config > 0) {
        return true
      }
    }
    return false
  }

  /**
   * 第一カラムの名称
   */
  get firstColumnTitle(): string {
    return this.conditions.columnTitle
      ? this.conditions.columnTitle
      : 'Documents'
  }

  /**
   * PDF以外のリンク
   */
  get pageLinks(): PageLink[] {
    return this.conditions.pageLinks ?? []
  }

  // --------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * PDFに紐づくコンフィグが存在するかの可否
   */
  private hasConfig(item: DownloadLinkInfo): boolean {
    return this.getConfigModalId(item) > 0
  }

  /**
   * PDFに紐づくコンフィグのモーダルID
   */
  private getConfigModalId(item: DownloadLinkInfo): number {
    if (this.conditions.configList) {
      const config = this.conditions.configList.find(
        (d) => d.documentId === item.entityId
      )
      if (config) {
        return config.configId
      }
    }
    return 0
  }

  /**
   * Moreボタンクリック時
   */
  private clickMore(item: DownloadLinkInfo) {
    const configModal = document.getElementById('config-modal')
    const configModalCloseButton = document.getElementById('config-modal-close')
    // configModal、Moreボタン、閉じるボタンがない時は終了
    if (!configModal || !configModalCloseButton) {
      return
    }

    // モーダル表示
    configModal.classList.remove('is-invisible')

    // クリックされたボタンのID取得
    const tableId = 'config-' + this.getConfigModalId(item) + '-table'
    const configTable = document.getElementById(tableId)

    this.sendGTMEvent(item)

    // テーブル表示
    if (configTable) {
      configTable.classList.remove('is-invisible')

      // イベントを設定していない場合、新たに設定
      if (!this.clicked.includes(item.id)) {
        // テーブル配下のformへのリンクにパラメータを追加
        const fullTables = configTable.querySelectorAll<HTMLAnchorElement>(
          'a.js-configModalInquiry'
        )
        fullTables.forEach((element) => {
          const url = new GetParameter(element.href)
          url.set('button_from', 'applications')
          url.set(
            'your_product_analytical_requirements_service_needs',
            item.title
          )
          element.href = url.getHref()
        })

        // クローズボタンクリック時のイベント追加
        configModalCloseButton.addEventListener('click', function () {
          configTable.classList.add('is-invisible')
        })

        // イベント設定済みに追加
        this.clicked.push(item.id)
      }
    }
  }

  /**
   * ConfigのMoreボタンの元となるPDFファイルのURLをGTMへ送信
   */
  private sendGTMEvent(item: DownloadLinkInfo) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'ConfigurationMoreBtnClickEvent',
      'pdf-url': item.url
    })
  }

  /**
   * リンククリック時の動作
   */
  private linkClick(url: string) {
    if (window.iwgp?.existDlEvent) {
      // DLイベントが定義されている場合は、DLイベントを発生させる
      createCustomEvent('start-pdf-download', { url: url })
    } else {
      // DLイベントが定義されていない場合は、そのまま画面遷移させる
      window.location.href = url
    }
  }
}
